import { render } from "./KcTags.vue?vue&type=template&id=4273a196"
import script from "./KcTags.vue?vue&type=script&lang=js"
export * from "./KcTags.vue?vue&type=script&lang=js"

import "./KcTags.vue?vue&type=style&index=0&id=4273a196&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__